export default "__VITE_ASSET__ee1eee74__"